import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "book-reading-nav" }
const _hoisted_2 = { class: "book-reading-nav__container" }
const _hoisted_3 = { class: "book-reading-nav__link" }
const _hoisted_4 = { class: "book-reading-nav__container" }
const _hoisted_5 = { class: "book-reading-nav__name book-reading-nav__next-name" }

import { backLink } from '@/models/backlink'
import { ArticleView } from '@/models/doc.article'


export default /*@__PURE__*/_defineComponent({
  __name: 'PrevNext',
  props: {
    article: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: _unref(backLink).previousPage.fullPath,
        class: "article-single__publisher-link book-reading-nav__prev-box"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _cache[0] || (_cache[0] = _createElementVNode("span", { class: "book-reading-nav__ihon iconfont iprev" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(_unref(backLink).previousPageLabel), 1)
          ])
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (__props.article.nextLink)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: __props.article.nextLink.route,
            class: "article-single__next-link book-reading-nav__next-box"
          }, {
            default: _withCtx(() => [
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "book-reading-nav__link book-reading-nav__next" }, [
                _createTextVNode(" Next Article"),
                _createElementVNode("span", { class: "book-reading-nav__icon iconfont inext" })
              ], -1)),
              _createElementVNode("p", _hoisted_5, _toDisplayString(__props.article.nextLink.title), 1)
            ]),
            _: 1
          }, 8, ["to"]))
        : (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            to: { name: 'articles' },
            class: "article-single__next-link book-reading-nav__next-box"
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createElementVNode("div", { class: "book-reading-nav__link book-reading-nav__next" }, [
                _createTextVNode(" Back to Articles"),
                _createElementVNode("span", { class: "book-reading-nav__icon iconfont inext" })
              ], -1)
            ]))]),
            _: 1
          }))
    ])
  ]))
}
}

})